import { useEffect, useState } from 'react';

export default function MaintenanceScreen() {
  const [now] = useState(
    new Date().toLocaleString(undefined, {
      dateStyle: 'medium',
      timeStyle: 'short',
    })
  ); // Set the current local date and time (formatted nicely)

  useEffect(() => {
    const retryAfter =
      Number((document.cookie.match(/(?:^|;)\s*retryAfter=(\d+)/) || [])[1]) ||
      0; // Try to read the 'retryAfter' value (in seconds) from the cookie

    if (retryAfter > 0 && retryAfter < 3600) {
      // If a valid retryAfter value exists (between 1 and 3599 seconds)
      const id = setTimeout(
        () => window.location.reload(),
        (retryAfter + 3) * 1000
      ); // Set a timer to reload the page after that time + 3 seconds buffer

      return () => clearTimeout(id); // Clean up the timer if the component is unmounted
    }
  }, []);

  return (
    <div className="maintenance-root">
      <main className="maintenance-main">
        <h1 className="maintenance-h1">We&rsquo;ll be right&nbsp;back</h1>

        <p className="maintenance-p">
          We&rsquo;re doing some quick maintenance to keep things running
          smoothly. Please try again in a few minutes.
        </p>

        <small className="maintenance-small">Last updated: {now}</small>
      </main>
    </div>
  );
}
